import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
  modalMain: {
    minHeight: '150px',
  },
  modal: {
    maxWidth: '900px',
  },
  wrapper: {
    gap: '10px',
    width: '400px',
    display: 'flex',
    flexDirection: 'column',
  },
  modalContent: {
    width: '100%',
    height: '150px',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '20px',
    paddingBottom: 0,
  },
}))
